













































































































































import { mapGetters, mapState } from 'vuex'
import { USER_NS } from '~/store/modules/shared/user/state'
import { CLASSIFIED_VIEW_NS } from '~/store/modules/shared/classifieds/view/state'
import DefaultSpecificationValue from '~/components/car/classifieds/view/partials/Specifications/DefaultSpecificationValue.vue'
import CategorySpecification from '~/components/car/classifieds/view/partials/Specifications/CategorySpecification.vue'
import PriceSpecification from '~/components/car/classifieds/view/partials/Specifications/PriceSpecification.vue'
import FuelConsumptionSpecification from '~/components/car/classifieds/view/partials/Specifications/FuelConsumptionSpecification.vue'
import LinkSpecification from '~/components/car/classifieds/view/partials/Specifications/LinkSpecification.vue'
import RegistrationSpecification from '~/components/car/classifieds/view/partials/Specifications/RegistrationSpecification.vue'
import ParkedSpecification from '~/components/car/classifieds/view/partials/Specifications/ParkedSpecification.vue'
import { Specification } from '~/models/classified/types'
import { faShoppingCart } from '@fortawesome/free-solid-svg-icons'
import { CategoryId } from '~/models/category/types'
import { USER_AGENT_NS } from '~/store/modules/shared/userAgent/state'
import SpecificationViewService from '~/services/SpecificationViewService'
import LeasingSpecification from '~/components/car/classifieds/view/partials/Specifications/LeasingSpecification.vue'
import GoToConcactSpecification from '~/components/car/classifieds/view/partials/Specifications/GoToConcactSpecification.vue'
import DealerSiteService from '~/services/dealers/site/DealerSiteService'
import CCard from '~/components/shared/configurable/card/CCard.vue'
import CExpandableContent from '~/components/shared/configurable/expand/CExpandableContent.vue'
import CTable from '~/components/shared/configurable/table/CTable.vue'
import CTableRow from '~/components/shared/configurable/table/CTableRow.vue'
import CTableBody from '~/components/shared/configurable/table/CTableBody.vue'
import CTableDataCell from '~/components/shared/configurable/table/CTableDataCell.vue'
import { defineComponent } from '@nuxtjs/composition-api'
import { defineVue3AsyncComponent } from '~/utils/nuxt3-migration'

export default defineComponent({
  components: {
    CExpandableContent,
    CCard,
    GoToConcactSpecification,
    CategorySpecification,
    ForMakeModelSpecification: defineVue3AsyncComponent(() =>
      import(
        '~/components/car/classifieds/view/partials/Specifications/ForMakeModelSpecification.vue'
      )
    ),
    DefaultSpecificationValue,
    ExtraTelephoneSpecification: defineVue3AsyncComponent(() =>
      import(
        '~/components/car/classifieds/view/partials/Specifications/custom/ExtraTelephoneSpecification'
      )
    ),
    FinanceSpecification: defineVue3AsyncComponent(() =>
      import(
        '~/components/car/classifieds/view/partials/Specifications/FinanceSpecification.vue'
      )
    ),
    PriceSpecification,
    FuelConsumptionSpecification,
    LinkSpecification,
    RegistrationSpecification,
    OfferTypeSpecification: defineVue3AsyncComponent(() =>
      import(
        '~/components/car/classifieds/view/partials/Specifications/OfferTypeSpecification.vue'
      )
    ),
    ParkedSpecification,
    LeasingSpecification,
    CTable,
    CTableRow,
    CTableBody,
    CTableDataCell
  },
  props: {
    specifications: { type: Array, required: true },
    extraSpecifications: {
      type: Array,
      required: false,
      default() {
        return []
      }
    },
    categoryId: { type: Number, required: false, default: null },
    jobsLayout: { type: Boolean, required: false, default: false },
    withoutCard: { type: Boolean, required: false, default: false },
    preExpanded: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(USER_NS, {
      userIsAdmin: 'isAdmin'
    }),
    isDealerSite() {
      return this.$dep(DealerSiteService).routeIsOfDealerSite()
    },
    ...mapGetters(CLASSIFIED_VIEW_NS, {
      isPartClassified: 'isPartClassified',
      isXymaClassified: 'isXymaClassified',
      sellerOnlyContactViaMessages: 'sellerOnlyContactViaMessages'
    }),
    ...mapGetters(USER_AGENT_NS, {
      isMobile: 'isMobile'
    }),
    ...mapState(CLASSIFIED_VIEW_NS, {
      classifiedId: state => state.classified.id,
      seller: state => state.seller
      // catalogueShops: state => state.classified.catalogue_shops
    }),
    ...mapGetters(CLASSIFIED_VIEW_NS, [
      'sellerIsBlacklistedSuspiciousOrFraudster'
    ]),
    id() {
      return this.$dep(SpecificationViewService).getSpecificationTableId()
    },
    icons: () => ({
      shoppingCart: faShoppingCart
    }),
    bodyClasses() {
      if (this.jobsLayout) {
        return ['tw-p-0']
      }
      return []
    },
    allSpecifications(): Specification[] {
      const hardcodedSpecifications = [] // use this to add hardcoded specs

      if (!this.sellerIsBlacklistedSuspiciousOrFraudster) {
        if (this.seller.extra_telephone || this.seller.telephone1) {
          const telephoneSpec = {
            name: 'telephone',
            label: this.$t('telephone')
          }
          hardcodedSpecifications.push(telephoneSpec)
        }

        if (this.sellerOnlyContactViaMessages) {
          const telephoneSpec = {
            name: 'message-only',
            label: this.$t('telephone')
          }
          hardcodedSpecifications.push(telephoneSpec)
        }
      }
      return [
        ...(this.specifications.filter(
          s => s.name && (s.value || s.value === 0)
        ) as any[]),
        ...(this.extraSpecifications.filter(
          s => s.name && (s.value || s.value === 0)
        ) as any[]),
        ...(hardcodedSpecifications as any)
      ].filter(specification => {
        return specification.value !== null
      })
    },
    isXyma(): boolean {
      return CategoryId.XYMA === this.categoryId
    },
    isPlot(): boolean {
      return CategoryId.PLOT === this.categoryId
    },
    isVehicle(): boolean {
      return ![
        CategoryId.PARTS,
        CategoryId.JOBS,
        CategoryId.PLOT,
        CategoryId.XYMA
      ].includes(this.categoryId)
    },
    allPhones() {
      const allPhones = []
      if (this.seller.extra_telephone || this.seller.telephone1) {
        allPhones.push({
          value: this.seller.extra_telephone || this.seller.telephone1,
          extra_name: this.seller.extra_name || null
        })
      }
      if (this.seller.telephone2) {
        allPhones.push({
          value: { ...this.seller.telephone2, social: null }
        })
      }
      if (this.seller.mobile) {
        allPhones.push({
          value: { ...this.seller.mobile, social: null }
        })
      }

      return allPhones
    }
  },
  methods: {
    getExtraInfo(specification) {
      if (specification.extra_info) {
        return specification.extra_info
      }

      if (specification.name === 'registration') {
        return this.$t(
          'please make sure that the listed registration is the date of the first declaration, e.g. if it was registered abroad then that is the valid date.'
        )
      }
      return null
    }
  }
})
